import { useEffect, useMemo, useState } from "react";
import { Container, Navbar, Nav, Image, Dropdown } from "react-bootstrap";
import { Logo, Person } from "../assets/images";
import {
  BsPerson,
  BsBagCheck,
  BsBoxArrowRight,
  BsChevronDown,
} from "react-icons/bs";
import { NavLink, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { HeaderLoader } from "./loder";
import JotFormComponent from "./jotzform";
import { ConnectionModel } from "./modal";
import { table } from "@/utils/constant";
import { ReactInternetSpeedMeter } from "react-internet-meter";
import { constant, CONNECTION_THRESHOLDS } from "../utils/constant";

function Header({
  handleShow,
  handleShowPracticeRun,
  handleAscending,
  guestParticipants,
  location,
  userData,
  socket,
}) {
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [internetSpeed, setInternetSpeed] = useState(16);
  const [speed, setSpeed] = useState([100, 0, 0, 0, "Good"]);
  const [status, setStatus] = useState("");
  const [isFirstShow, setIsFirstShow] = useState(true);
  const [isOnline, setIsOnline] = useState(true);
  const [isOpenConnectionModel, setOpenConnectionModel] = useState(false);
  const [messageIndex, setMessageIndex] = useState(0);
  const [currentMessage, setCurrentMessage] = useState("");
  const [messageVisible, setMessageVisible] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    // IDOR Protection: Clear socket user credentials on logout
    if (socket && socket.clearUserCredentials) {
      socket.clearUserCredentials();
    }
    navigate("/");
  };
  const purchaseModal = () => {
    setShowPurchaseModal(!showPurchaseModal);
  };

  useEffect(() => {
    if (!window.Worker) return;

    const worker = new Worker(new URL("../worker.js", import.meta.url));

    const initializeWorker = (w) => {
      w.postMessage({
        apiUrl: process.env.REACT_APP_API_URL,
        origin: window.location.origin,
      });

      const handleSubscription = () => {
        if (socket && socket.connected) {
          socket.emit("check-supabase-connection", {}, (response) => {
            if (response && response.success) {
              setIsOnline(response.isConnected);
            } else {
              setIsOnline(false);
            }
          });
        } else {
          setIsOnline(false);
        }
      };

      handleSubscription();

      w.onmessage = async (e) => {
        if (e.data.error) {
          setSpeed([0, 0, 0, 0, "Bad"]);
        } else {
          setSpeed([
            e.data.download[0],
            e.data.download[1],
            e.data.download[2],
            e.data.download[3],
            e.data.serverConnection,
          ]);
        }
      };

      return w;
    };

    const initializedWorker = initializeWorker(worker);

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        worker.postMessage("pause");
      } else {
        worker.postMessage("resume");
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      initializedWorker.terminate();
    };
  }, []);
  
  const connection_issue = `data:image/svg+xml,${encodeURIComponent(`<svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.416 0.130284C11.1315 0.235908 9.69966 0.742687 9.76048 2.2737C10.566 6.9062 11.2584 11.5707 12.1493 16.1819C12.5792 16.8743 13.5309 16.7356 13.7528 15.9525C14.5093 11.3029 15.3863 6.66188 16.051 2.00377C15.9347 0.33513 13.7326 0.0225265 12.416 0.130284Z" fill="white" fill-opacity="0.4"/>
    <path d="M8.04403 3.8549C7.64074 3.91784 6.67626 4.34354 6.26443 4.52491C5.16765 5.00929 4.025 5.6793 3.03384 6.35465C2.49612 6.7206 0.850957 7.87499 0.555425 8.35083C-0.0377745 9.30678 1.03233 10.4622 2.05869 9.95973C3.65905 8.66984 5.33196 7.43756 7.22358 6.60218C7.94694 6.28317 9.33499 6.06446 9.48435 5.18746C9.63372 4.31046 8.90076 3.7194 8.0451 3.8549H8.04403Z" fill="white" fill-opacity="0.4"/>
    <path d="M17.1532 3.85379C16.4907 3.98822 16.1471 4.814 16.4117 5.42214C16.6763 6.03027 17.3207 6.08148 17.8734 6.30447C19.4247 6.93074 20.7903 7.71278 22.1389 8.69754C22.5891 9.02614 23.6496 10.028 24.1201 10.0728C25.0654 10.1624 25.7642 9.16697 25.2574 8.35079C25.0035 7.94323 23.7574 7.0481 23.3114 6.72803C22.0364 5.81049 19.3169 4.13972 17.8094 3.86659C17.6216 3.83245 17.3367 3.81751 17.1532 3.85485V3.85379Z" fill="white" fill-opacity="0.4"/>
    <path d="M16.0353 8.9675C15.0324 9.14034 14.8628 10.6287 15.8358 11.112C16.8088 11.5953 17.64 11.7969 18.6226 12.4798C19.0429 12.7721 19.6447 13.4165 20.128 13.4773C21.1703 13.6075 21.8254 12.4574 21.1842 11.623C20.6806 10.9669 18.773 9.85304 17.9846 9.49562C17.4458 9.2513 16.62 8.86721 16.0332 8.96857L16.0353 8.9675Z" fill="white" fill-opacity="0.4"/>
    <path d="M9.21596 9.02087C8.23227 9.17557 5.39858 10.7994 4.69975 11.5356C3.94758 12.3283 4.58666 13.6139 5.68344 13.4763C6.13901 13.4197 6.52843 12.9748 6.90184 12.7241C7.52172 12.3069 8.13945 11.9175 8.82227 11.6081C9.45708 11.3211 10.4962 11.1878 10.6115 10.3609C10.7374 9.4583 10.1068 8.88004 9.21703 9.01981L9.21596 9.02087Z" fill="white" fill-opacity="0.4"/>
    <path d="M10.0682 13.4944C9.50699 13.5914 8.01546 14.6317 7.69432 15.115C7.1374 15.9514 7.86929 17.0482 8.87112 16.8775C9.29255 16.806 9.73424 16.2747 10.097 16.0261C10.4939 15.7541 11.0455 15.6111 11.2781 15.1822C11.7454 14.3201 11.0348 13.3268 10.0682 13.4944Z" fill="white" fill-opacity="0.4"/>
    <path d="M15.2893 13.4944C14.456 13.6363 14.1072 14.7288 14.6651 15.3711C14.8913 15.6314 15.4013 15.8127 15.715 16.0261C16.0959 16.2843 16.5397 16.8263 16.9857 16.885C17.8371 16.9991 18.442 16.263 18.2745 15.4372C18.1507 14.8291 16.3413 13.5893 15.7427 13.4944C15.5934 13.4709 15.4376 13.4688 15.2882 13.4944H15.2893Z" fill="white" fill-opacity="0.4"/>
    <path d="M12.7897 17.4355C10.6911 17.5999 10.6826 20.7323 12.7737 20.8827C15.2458 21.0609 15.1892 17.2478 12.7897 17.4355Z" fill="white" fill-opacity="0.4"/>
    <path d="M12.4161 0.130285C13.7326 0.0225281 15.9347 0.335131 16.051 2.0027C15.3863 6.66081 14.5093 11.3018 13.7529 15.9514C13.531 16.7345 12.5793 16.8732 12.1493 16.1808C11.2585 11.5686 10.5671 6.90513 9.76054 2.27263C9.69866 0.741622 11.1304 0.234842 12.4161 0.129219V0.130285Z" fill="white"/>
    <path d="M8.04406 3.85492C8.89972 3.72049 9.63695 4.29021 9.48332 5.18748C9.32968 6.08475 7.94591 6.28212 7.22254 6.6022C5.32985 7.43758 3.65801 8.66986 2.05766 9.95974C1.03129 10.4623 -0.0388121 9.3068 0.554387 8.35085C0.84992 7.87501 2.49509 6.72062 3.03281 6.35467C4.02396 5.67932 5.16662 5.00931 6.2634 4.52493C6.67629 4.34249 7.64077 3.91786 8.04299 3.85492H8.04406Z" fill="white" fill-opacity="0.4"/>
    <path d="M17.1528 3.85388C17.3363 3.81654 17.6222 3.83147 17.8089 3.86561C19.3154 4.13874 22.036 5.80951 23.3109 6.72705C23.7569 7.04819 25.003 7.94226 25.257 8.34981C25.7648 9.16706 25.0649 10.1614 24.1196 10.0718C23.6502 10.027 22.5886 9.02517 22.1384 8.69656C20.7888 7.71181 19.4231 6.93083 17.8729 6.30349C17.3203 6.08051 16.6855 6.0517 16.4113 5.42116C16.1371 4.79062 16.4902 3.98724 17.1528 3.85281V3.85388Z" fill="white" fill-opacity="0.4"/>
    <path d="M16.0352 8.96747C16.622 8.86612 17.4478 9.2502 17.9866 9.49452C18.775 9.85194 20.6816 10.9658 21.1862 11.6219C21.8275 12.4563 21.1724 13.6064 20.13 13.4762C19.6456 13.4154 19.0439 12.771 18.6246 12.4787C17.642 11.7958 16.8333 11.6049 15.8379 11.1109C14.8424 10.6169 15.0345 9.13924 16.0374 8.9664L16.0352 8.96747Z" fill="white" fill-opacity="0.4"/>
    <path d="M9.21654 9.0208C10.1063 8.87997 10.7369 9.4593 10.611 10.3619C10.4958 11.1887 9.45659 11.3221 8.82178 11.6091C8.13897 11.9174 7.52123 12.3079 6.90136 12.7251C6.52901 12.9758 6.13959 13.4207 5.68295 13.4773C4.58617 13.6138 3.9471 12.3282 4.69926 11.5366C5.39809 10.8004 8.23285 9.17657 9.21547 9.02186L9.21654 9.0208Z" fill="white" fill-opacity="0.4"/>
    <path d="M12.7897 17.4355C15.1903 17.2478 15.2468 21.0609 12.7737 20.8827C10.6826 20.7323 10.6911 17.5999 12.7897 17.4355Z" fill="white"/>
    <path d="M15.2896 13.4944C15.4389 13.4688 15.5947 13.4709 15.7441 13.4944C16.3415 13.5893 18.151 14.8291 18.2758 15.4372C18.4433 16.263 17.8384 16.9981 16.987 16.885C16.541 16.8252 16.0972 16.2843 15.7163 16.0261C15.4026 15.8138 14.8927 15.6314 14.6665 15.3711C14.1085 14.7298 14.4563 13.6373 15.2906 13.4944H15.2896Z" fill="white" fill-opacity="0.4"/>
    <path d="M10.0682 13.4944C11.0337 13.3268 11.7454 14.3201 11.2781 15.1822C11.0455 15.6111 10.4939 15.753 10.097 16.0261C9.73424 16.2747 9.29255 16.806 8.87112 16.8775C7.86929 17.0482 7.1374 15.9514 7.69432 15.115C8.01546 14.6317 9.50699 13.5914 10.0682 13.4944Z" fill="white" fill-opacity="0.4"/>
    </svg>`)}`;

  const { barsFilled, messages, redCount } = useMemo(() => {
    const tempMessages = [];
    let yellowCount = 0;
    let redCount = 0;

    if (speed[0] < CONNECTION_THRESHOLDS.DOWNLOAD_SPEED_RED || speed[2] >= CONNECTION_THRESHOLDS.PING_RED || speed[4] === "Bad" || !isOnline) {
      if (speed[0] < CONNECTION_THRESHOLDS.DOWNLOAD_SPEED_RED) redCount++;
      if (speed[2] >= CONNECTION_THRESHOLDS.PING_RED) redCount++;
      if (speed[4] === "Bad") redCount++;
    }

    if (redCount >= 1) {
      if (speed[0] < CONNECTION_THRESHOLDS.DOWNLOAD_SPEED_RED) {
        tempMessages.push("Connection Speed Lost");
      }
      if (speed[2] >= CONNECTION_THRESHOLDS.PING_RED) {
        tempMessages.push("Network Responsiveness Lost");
      }
      if (speed[4] === "Bad") {
        tempMessages.push("Server Connection Lost");
      }
    }

    // Check for yellow conditions
    if (
      (speed[0] >= CONNECTION_THRESHOLDS.DOWNLOAD_SPEED_RED && speed[0] < CONNECTION_THRESHOLDS.DOWNLOAD_SPEED_GREEN) ||
      (speed[2] >= CONNECTION_THRESHOLDS.PING_WARNING && speed[2] < CONNECTION_THRESHOLDS.PING_RED) ||
      speed[4] === "Average"
    ) {
      if (speed[0] >= CONNECTION_THRESHOLDS.DOWNLOAD_SPEED_RED && speed[0] < CONNECTION_THRESHOLDS.DOWNLOAD_SPEED_GREEN) yellowCount++;
      if (speed[2] >= CONNECTION_THRESHOLDS.PING_WARNING && speed[2] < CONNECTION_THRESHOLDS.PING_RED) yellowCount++;
      if (speed[4] === "Average") yellowCount++;
    }

    if (yellowCount >= 1) {
      if (speed[0] >= CONNECTION_THRESHOLDS.DOWNLOAD_SPEED_RED && speed[0] < CONNECTION_THRESHOLDS.DOWNLOAD_SPEED_GREEN) {
        tempMessages.push("Connection Speed Unstable");
      }
      if (speed[2] >= CONNECTION_THRESHOLDS.PING_WARNING && speed[2] < CONNECTION_THRESHOLDS.PING_RED) {
        tempMessages.push("Network Responsiveness Unstable");
      }
      if (speed[4] === "Average") {
        tempMessages.push("Server Connection Unstable");
      }
    }

    if(status === `Database connection: Bad`){
      tempMessages.push("Database Connection Lost");
      redCount++;
    }

    const calculatedBarsFilled =
      yellowCount === 1 ? 2 : yellowCount >= 2 ? 1 : 3;

    return { barsFilled: calculatedBarsFilled, messages: tempMessages, redCount };
  }, [speed, isOnline]);

  // Reset message index when messages change
  useEffect(() => {
    if (messages.length > 0) {
      setMessageIndex(0);
      setIsFirstShow(true);
    }
  }, [messages]);

  // Message cycling effect
  useEffect(() => {
    if (messages.length > 0) {
      let showTimeout;
      let hideTimeout;

      const cycleMessages = () => {
        setCurrentMessage(messages[messageIndex]);
        setMessageVisible(true);

        showTimeout = setInterval(() => {
          setMessageIndex((prevIndex) =>
            prevIndex + 1 !== messages.length ? prevIndex + 1 : 0
          );
          setMessageVisible(false);
          hideTimeout = setTimeout(() => {
            if (isFirstShow) {
              setIsFirstShow(false);
            } else {
              setIsFirstShow(true);
            }
          }, 1000);
        }, 3000);
      };

      // Start the cycle
      cycleMessages();

      return () => {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
      };
    } else {
      setMessageVisible(false);
      setCurrentMessage("");
    }
  }, [messages, messageIndex, isFirstShow]);

  const renderNetworkDesign = () => {
    return internetSpeed > 2 && redCount < 3 ? (
      <>
        {currentMessage && messageVisible && (
          <div className="my-auto text-white" style={{ fontSize: "13px" }}>
            {currentMessage}
          </div>
        )}
        <div className="signale cursor-pointer" onClick={openConnectionModel}>
          {[...Array(3)].map((_, index) => {
            const className = index < barsFilled ? "" : "signale_deactivate";
            return <span key={index} className={className}></span>;
          })}
        </div>
      </>
    ) : (
      <p className="text-white cursor-pointer" onClick={openConnectionModel}>
        <Image
          src={connection_issue}
          fluid
          style={{ marginBottom: "4px" }}
          alt=""
        />{" "}
        {constant?.connectionIssue}
      </p>
    );
  };

  const openConnectionModel = () => {
    setOpenConnectionModel(!isOpenConnectionModel);
  };

  return (
    <>
      {!userData && !guestParticipants ? (
        <HeaderLoader />
      ) : (
        <>
          <Navbar variant="dark" bg="primary" className="py-4 px-0">
            <Container>
              <Navbar.Brand className="py-0">
                <NavLink to="/">
                  <Image className="h-6" src={Logo} />
                </NavLink>
              </Navbar.Brand>
              <Navbar.Toggle />
              <Navbar.Collapse>
                <Nav className="ms-auto gap-5">
                  {renderNetworkDesign()}
                  {!guestParticipants &&
                    location?.pathname !== "/connection" && (
                      <>
                        <Dropdown align="end" className="my-auto">
                          <Dropdown.Toggle
                            variant="none"
                            as={Link}
                            bsPrefix="px-0 link-white text-no-decoration text-base hstack"
                          >
                            <span className="font-regular me-1">Sessions</span>{" "}
                            <BsChevronDown className="text-sm mt-1" />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() =>
                                handleAscending && handleAscending(true)
                              }
                            >
                              {table?.upcomingSessions}
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() =>
                                handleAscending && handleAscending(false)
                              }
                            >
                              {table?.pastSessions}
                            </Dropdown.Item>
                            <Dropdown.Divider className="my-0" />
                            <Dropdown.Item
                              onClick={() => handleShow && handleShow()}
                            >
                              {table?.scheduleNewSession}
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => handleShowPracticeRun && handleShowPracticeRun()}
                            >
                              {table?.schedulePracticeRunSession}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown align="end" className="my-auto">
                          <Dropdown.Toggle
                            variant="none"
                            as={Link}
                            bsPrefix="px-0 link-white hstack gap-1 text-no-decoration text-inter font-semibold" //ls-widest
                          >
                            <Image src={Person} />{" "}
                            <span className="text-11 lh-snug">
                              {" "}
                              {!guestParticipants &&
                                userData?.organization?.name}
                            </span>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Header className="text-uppercase text-danger font-semibold">
                              <BsPerson className="text-lg me-2" />{" "}
                              {userData &&
                                userData?.user.first_name +
                                  " " +
                                  userData?.user.last_name}
                            </Dropdown.Header>
                            <Dropdown.Divider className="my-0" />
                            {[1, 2].includes(userData?.user?.role_id) && (
                              <Dropdown.Item onClick={purchaseModal}>
                                <BsBagCheck className="text-lg me-2" />
                                {table?.availableSeats}{" "}
                                {userData?.organization?.available_seat}
                              </Dropdown.Item>
                            )}
                            <Dropdown.Item onClick={handleLogout}>
                              <BsBoxArrowRight className="text-lg me-2" />
                              {table?.logout}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </>
                    )}
                  {guestParticipants &&
                    location?.pathname !== "/connection" && (
                      <NavLink
                        to={"/"}
                        className="text-no-decoration font-semibold btn btn-outline-light py-1 px-10"
                      >
                        {table?.facilitatorLogin}
                      </NavLink>
                    )}
                  {location?.pathname === "/connection" && (
                    <span className="text-common text-futura-medium text-white py-1">
                      {"Virtual Friday Night at the ER®"}
                    </span>
                  )}
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </>
      )}
      {showPurchaseModal && (
        <JotFormComponent
          show={showPurchaseModal}
          hide={() => purchaseModal()}
        />
      )}
      {isOpenConnectionModel && (
        <ConnectionModel
          show={isOpenConnectionModel}
          hide={() => setOpenConnectionModel(!isOpenConnectionModel)}
          internetSpeed={internetSpeed}
          setSpeed={setSpeed}
          speed={speed}
          status={status}
          setStatus={setStatus}
          socket={socket}
        />
      )}
      <ReactInternetSpeedMeter
        txtSubHeading=""
        outputType="alert"
        customClassName={null}
        txtMainHeading=""
        pingInterval={45000}
        thresholdUnit="megabyte"
        threshold={100}
        imageUrl="https://reactnative.dev/img/tiny_logo.png"
        downloadSize="1781287"
        callbackFunctionOnNetworkDown={(speed) => {}}
        callbackFunctionOnNetworkTest={(speed) => {
          setInternetSpeed(speed);
        }}
        callbackFunctionOnError={() => {
          setInternetSpeed(0);
        }}
      />
    </>
  );
}
export default Header;
